import { cn } from "@/lib/utils";
import type { EntryValueViewT } from "@patient-watch/types";
import { formatJoinedMeasurements, joinedMeasurementLabel } from "../../measurementRuns";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface JoinedMeasurementEntryValueProps extends Omit<BaseEntryValueProps, "inputLabel" | "children"> {
    entryValues: EntryValueViewT[];
}

export function JoinedMeasurementEntryValue({
    entryValues,
    size,
    className,
    ...props
}: JoinedMeasurementEntryValueProps) {
    const displayValue = formatJoinedMeasurements(entryValues) || "None";

    return (
        <BaseEntryValue inputLabel={joinedMeasurementLabel(entryValues)} size={size} className={className} {...props}>
            <div className="flex items-center bg-white/80 px-3 py-1 border border-slate-200 rounded-md w-fit">
                <span
                    className={cn(
                        "font-medium text-slate-900 dark:text-slate-200",
                        size === "sm" ? "text-sm" : size === "lg" ? "text-xl" : "text-md"
                    )}
                >
                    {displayValue}
                </span>
            </div>
        </BaseEntryValue>
    );
}
